export const rtApiUrl = {
  prod: (subdom: string) => `https://${subdom}.rt.451.io/`,
  stage: (subdom: string) => `https://${subdom}.rt-stage.451.io/`,
  dev: 'https://tu.development.rt-dev.451.io/'
};
